import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  Discipline,
  useDisciplinesTableContext,
} from '../../../../DisciplinesTableContext'
import { useCreateDsDisciplineMutation } from 'schema'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'
import { CreateEditFormItemValues } from '../../components/CreateEditFormItems/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<Discipline> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useDisciplinesTableContext()
  const [create] = useCreateDsDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createDSDiscipline: {
        discipline: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Discipline',
    permission: Permission.CreateDesignSubmittalDiscipline,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({ name, description, users }: CreateEditFormItemValues) => {
        await create({
          variables: {
            createDsDisciplineInput: {
              name,
              description,
              projectId,
              userIds: users?.map(({ value }) => value.toString()),
            },
          },
        })
        await refetch()
      },
    },
  }
}
